export const dashboardsMap: Record<string, string> = {
  ["DEALERNET-BDC - Desempenho Pós-Vendas"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/36fd9aed-d76a-4961-b527-7c01b26a4caf/",
  ["DEALERNET-PEÇAS - Desempenho do Fornecimento"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/7d086025-f3bf-454c-a26f-759a38784d11/",
  ["0-1-TABELAS - Cadastro de Metas e Comissões Pós-Vendas"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/83de96c3-1727-4409-b2cc-482ac9ce4662/",
  ["0-1-TABELAS - Cadastro de Metas Gerenciais"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/fa757d43-5fdb-4114-81a8-e966e06af0be/",
  ["0-1-TABELAS - Catalogo Toyota - Cadastro de M.O."]:
    "https://proxy.metoncloud.com.br/mercosul-bi/d2bd17d0-8265-47e2-85d9-307ab29544c0/",
  ["0-1-TABELAS - Editor de Cotações de Veiculos Usados"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/f6a595ce-4a31-43f5-b7b9-1c8bb1ceb450/",
  ["0-1-TABELAS - Rescisão do Colaborador"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/827788fa-fdfd-4ca4-91cf-4c547f17e7d3/",
  ["0-1-TABELAS - Cadastro de Resultados do Banco Toyota"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/d8e9b095-b8c0-40e1-9044-705039541a59/",
  ["0-1-TABELAS - Cadastro de Metas Gerenciais de Peças"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/abdbfe72-c858-4959-8a70-705fdccd1ca1/",
  ["0-2-AUTOMAÇÕES-OLD - Automação Webmotors - FIPE"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/6bc5cd79-8d23-4f40-ab44-4dc30fc568c1/",
  ["0-2-INTEGRAÇÕES - Consulta de Clientes por Chassi"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/421cae68-cb0f-43ca-be4c-4731ab597dfa/",
  ["0-2-INTEGRAÇÕES - Correção de Base Syonet para Disparos de Campanhas"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/e99f43c6-020c-497b-b2a0-cf43c7a10d1a/",
  ["DEALERNET-BDC - Desempenho Diário do Agente"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/fb315b90-aaba-4812-9792-f7765b9873b5/",
  ["TESTES - AUTH"]:
    "https://proxy.metoncloud.com.br/mercosul-bi/2927219b-10c7-4eef-96db-0ecc902bbaf0/",
  ["TOYOPAR - One Page Report"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro10/3ade3f70-93c4-4d5a-94a1-6d88753134be/",
  ["RAVPRO - ADMIN - SMS"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro9/4745a27d-aa9e-4c77-bc08-caf47e8d6b4c/",
  ["RAVPRO - ADMIN - PAINEL DE CONTROLE"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro7/e1148d47-6490-4a10-8881-bb301836d8cf/",
  ["RAVPRO - ADMIN - PREMIAÇÕES - ADMIN"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro4/a08d3c6f-b260-4058-adaa-3722c6831ce1/",
  ["RAVPRO - ADMIN - SANITIZANTES - DAF"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro8/6d2cc93e-6f16-4002-8e75-364ee709ed76/",
  ["RAVPRO - PREMIAÇÕES - Premiações Manuais"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro2/88b34eb3-b918-4ac1-86c2-123c7a663bed/",
  ["RAVPRO - PREMIAÇÕES - Premiações Integradas"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro1/36fd9aed-d76a-4961-b527-7c01b26a4caf/",
  ["RAVPRO - ACOMPANHAMENTO DE PEDIDOS"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro3/880aec16-4417-4e50-b5ce-8160961436df/",
  ["RAVPRO - OPR - MANUAIS"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro6/27e6b495-82e6-4da9-91ac-24a29a5a30d8/",
  ["RAVPRO - OPR - INTEGRADAS"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro5/4b57d159-080a-4f89-abf0-6e8e6e60ee64/",
  ["RAVPRO - PREMIAÇÕES - Premiações Integradas Gerentes"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro13/a50eb6c3-6715-43e0-86ce-969f7ff801c2/",
  ["RAVPRO - PREMIAÇÕES - Premiações Manuais Gerentes"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro14/30d9221c-262d-4c7d-80a9-8c47a50434bf/",
  ["RAVPRO - PREMIAÇÕES - Conferência e Validação"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro15/b3e4ab48-7ff3-4357-b9d8-74da2832c90b/",
  ["DAF - Fluxo de Atendimento"]:
    "https://proxy.dev-ravpro.scalar.ws/ravpro16/cfb407c0-8258-423d-8745-1d8411749d1e/",
};
